import { getWebClockIn, postWebClockIn, setClockInEndDate, setClockInStartDate, setClockInSwitch, setWebClockInLoading } from 'actions/attendanceNew';
import { Button, Checkbox, DatePicker, Modal, Switch } from 'antd';
import PageDataLoader from 'components/pageDataLoader';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Notification from "services/Notification";


const SettingModal = ({ setIsSettingModalOpen, isSettingModalOpen, getWebClockIn, storeClockInLoading, storeClockInData, storeUserId, postWebClockIn, setClockInStartDate, setClockInEndDate, setClockInSwitch, storeClockInStartDate,
  storeClockInEndDate,
  storeClockInSwitch }) => {
  // Helper to extract nested/array data safely
  const getParsedData = (raw) => {
    let data = Array.isArray(raw) ? raw[0] : raw;
    if (data && data.data) {
      data = Array.isArray(data.data) ? data.data[0] : data.data;
    }
    return data;
  };

  const getParsedSettings = (dataObj) => {
    let settings = dataObj?.settings;
    if (typeof settings === 'string') {
      try {
        settings = JSON.parse(settings);
      } catch (e) {
        console.error("Failed to parse settings JSON string", e);
      }
    }
    return settings;
  };

  const initialDataObj = getParsedData(storeClockInData);
  const initialSettings = getParsedSettings(initialDataObj);
  const [type, setType] = useState(initialSettings?.duration || 'Permanent')
  const [isSwitch, setSwitch] = useState(false)
  const [loader, setLoader] = useState(false);
  const [isNo, setIsNo] = useState(false)
  const [initialValues, setInitialValues] = useState({});
  const [hasChanges, setHasChanges] = useState(false);
  const isLoading = storeClockInLoading;

  // useEffect(() => {
  //   if (isSettingModalOpen) {
  //     setIsNo(false);
  //     const data = getParsedData(storeClockInData);
  //     const enabled = data ? (data.enabled === true || data.enabled === 1 || data.enabled === '1' || data.enabled === 'true') : false;
  //     setSwitch(enabled);

  //     const settings = getParsedSettings(data);
  //     const savedDuration = settings?.duration || "Permanent";
  //     setType(savedDuration);

  //     const savedStartDate = settings?.startDate && settings?.startDate !== 'Invalid date'
  //       ? moment(settings.startDate)
  //       : moment();
  //     const savedEndDate = settings?.endDate && settings?.endDate !== 'Invalid date'
  //       ? moment(settings.endDate)
  //       : moment();

  //     setClockInStartDate(savedStartDate);
  //     setClockInEndDate(savedEndDate);
  //   }
  // }, [isSettingModalOpen, storeClockInData, isNo]);
  useEffect(() => {
    if (isSettingModalOpen) {
      setIsNo(false);

      const data = getParsedData(storeClockInData);

      const enabled =
        data?.enabled === true ||
        data?.enabled === 1 ||
        data?.enabled === "1" ||
        data?.enabled === "true";

      const settings = getParsedSettings(data);

      // preserve saved duration
      // const savedDuration =
      //   settings?.duration === "Temporary"
      //     ? "Temporary"
      //     : "Permanent";

      // const savedStartDate =
      //   settings?.startDate &&
      //   settings?.startDate !== "Invalid date"
      //     ? moment(settings.startDate)
      //     : null;

      // const savedEndDate =
      //   settings?.endDate &&
      //   settings?.endDate !== "Invalid date"
      //     ? moment(settings.endDate)
      //     : null;
      const savedDuration =
        settings?.duration || "Permanent";

      const savedStartDate =
        settings?.startDate
          ? moment(settings.startDate)
          : null;

      const savedEndDate =
        settings?.endDate
          ? moment(settings.endDate)
          : null;

      // set values AFTER parsing
      setSwitch(enabled);
      setType(savedDuration);

      setClockInStartDate(savedStartDate);
      setClockInEndDate(savedEndDate);

      setInitialValues({
        enabled,
        duration: savedDuration,
        startDate: savedStartDate,
        endDate: savedEndDate,
      });

      setHasChanges(false);
    }
  }, [isSettingModalOpen, storeClockInData]);
  useEffect(() => {
    const changed =
      initialValues.enabled !== isSwitch ||
      initialValues.duration !== type ||
      (
        moment(initialValues.startDate).format("YYYY-MM-DD") !==
        moment(storeClockInStartDate).format("YYYY-MM-DD")
      ) ||
      (
        moment(initialValues.endDate).format("YYYY-MM-DD") !==
        moment(storeClockInEndDate).format("YYYY-MM-DD")
      );

    setHasChanges(changed);
  }, [
    isSwitch,
    type,
    storeClockInStartDate,
    storeClockInEndDate,
    initialValues
  ]);

  const handleOk = () => {
    setIsNo(true)
    setIsSettingModalOpen(false);
  };

  const handleCancel = () => {
    setIsSettingModalOpen(false);
    setClockInStartDate(null);
    setClockInEndDate(null);
    setType('');
    setIsNo(false);
  };

  const handleStartDateChange = (date) => {
    setClockInStartDate(date)
  };

  const handleEndDateChange = (date) => {
    setClockInEndDate(date)
  };

  const OnChangePermanent = (id) => {
    if (type == '') {
      id == 0 ? setType("Permanent") : setType("Temporary")
    } else if (type === "Permanent") {
      setType('Temporary')
    } else if (type !== "Permanent") {
      setType("Permanent")
    }
  };

  const disabledDate = (current) => {
    return current && current < moment().startOf('day');
  };

  const disabledEndDate = (current) => {
    //disable end date based on start date
    return current && current <= moment(storeClockInStartDate, "DD/MM/YYYY").subtract(1, 'day').endOf('day');
  };
  const isYesDisabled = !hasChanges || (isSwitch && type === "Temporary" && (!storeClockInStartDate || !storeClockInEndDate || moment(storeClockInStartDate).isAfter(storeClockInEndDate)));

  return (
    <>
      <Modal
        className="modal-round-corner"
        open={isSettingModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <div style={{ position: "relative" }}>
          {/* <PageDataLoader visible={isLoading} modalLoader={true} showSideMenu={false} widthOfMenu={0} /> */}
          {isLoading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 9999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "20px",
              }}
            >
              <PageDataLoader
                visible={true}
                modalLoader={true}
              />
            </div>
          )}
          <div>
            <div style={{ fontSize: "21px", fontWeight: "bold", textAlign: "center" }}>Setting</div>
            <div style={{ display: "flex", marginTop: "30px" }}>
              <div>
                <div style={{ fontSize: "16px", fontWeight: "bold" }}>Web clock in/clock out</div>
                <div style={{ fontSize: "14px", color: "#636363", fontWeight: "bold" }}>Enable web clock in/clock out and control it’s duration.</div>
              </div>

              <div style={{ marginLeft: "50px", marginTop: "20px" }}>
                {/* <Switch checked={isSwitch} onChange={(e) => { setSwitch(e) }} /> */}
                <Switch checked={isSwitch}
                  onChange={(checked) => {
                    setSwitch(checked);

                    // Disabled → Enabled
                    if (checked && !initialValues.enabled) {
                      setType("Permanent");
                      setClockInStartDate(null);
                      setClockInEndDate(null);
                    }

                    // Enabled → Disabled
                    if (!checked) {
                      setType("Permanent");
                      setClockInStartDate(null);
                      setClockInEndDate(null);
                    }
                  }}
                />
              </div>
            </div>
            {isSwitch ?
              (
                <>
                  <div style={{ marginTop: "20px", fontSize: "12px", color: "#636363", fontWeight: "bold" }}>Duration</div>
                  <div style={{ display: "flex", justifyContent: "space-between", width: "100%", marginTop: "20px" }}>
                    <div style={{ display: "flex", marginLeft: "10px" }}>
                      <Checkbox onChange={(e) => { if (e.target.checked) setType("Permanent"); }} checked={type === "Permanent"} />
                      <div style={{ fontSize: "14px", marginLeft: "20px", color: "#191919", font: " normal normal normal 16px/21px Roboto" }}>Permanent</div>
                    </div>
                    <div style={{ fontSize: "14px", marginRight: "52px" }}><Checkbox onChange={(e) => { if (e.target.checked) {setType("Temporary"); if (initialValues.duration !== "Temporary") { setClockInStartDate(null); setClockInEndDate(null);}} }} checked={type === "Temporary"}>Temporary</Checkbox></div>
                  </div>
                  {type == "Permanent" ? null :
                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", width: "100%", marginTop: "20px" }}>
                        <div>
                          <div style={{ marginLeft: "30px", fontSize: "14px" }}>Start date</div>
                          <div style={{ marginLeft: "30px" }} >
                            <DatePicker format="DD-MM-YYYY"
                              disabledDate={disabledDate}
                              value={storeClockInStartDate && moment(storeClockInStartDate).isValid() ? moment(storeClockInStartDate) : null}
                              onChange={(value) => { handleStartDateChange(value) }}
                            />
                          </div>
                        </div>
                        <div>
                          <div style={{ marginLeft: "50px", fontSize: "14px" }}>End date</div>
                          <div style={{ marginLeft: "50px" }} >
                            <DatePicker format="DD-MM-YYYY"
                              disabledDate={disabledEndDate}
                              value={storeClockInEndDate && moment(storeClockInEndDate).isValid() ? moment(storeClockInEndDate) : null}
                              onChange={(value) => { handleEndDateChange(value) }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </>
              )
              : null}
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                marginTop: "30px",
              }}
            >
              <div>
                <Button
                  style={{
                    borderRadius: "19px",
                    width: "120px",
                    height: "35px",
                    border: "1px solid  #636363",
                    backgroundColor: "#FFFFFF",
                    color: "#594099",
                  }}
                >
                  <div
                    style={{
                      fontSize: "16px",
                      color: "#636363",
                      fontWeight: "bold",
                    }}
                    onClick={handleOk}
                  >
                    NO
                  </div>
                </Button>
              </div>
              <div>
                <Button
                  loading={loader}
                  // disabled={isSwitch && type === "Temporary" && (moment(storeClockInStartDate).format('YYYY-MM-DD') > moment(storeClockInEndDate).format('YYYY-MM-DD'))}
                  disabled={isYesDisabled}
                  style={{
                    borderRadius: "19px",
                    width: "120px",
                    height: "35px",
                    border: "1px solid #594099 ",
                    backgroundColor: "#594099",
                    fontSize: "16px",
                    color: "#FFFFFF",
                    fontWeight: "bold",
                    opacity: isYesDisabled ? 0.5 : 1,
                  }}
                  onClick={() => {
                    setLoader(true)
                    postWebClockIn(isSwitch, storeUserId, type, () => { setIsSettingModalOpen(false); setLoader(false) })
                  }}
                >
                  YES
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  const { storeClockInData, storeClockInStartDate, storeClockInEndDate, storeClockInSwitch, storeClockInLoading } = state.attendanceNew;
  return { storeClockInData, storeClockInStartDate, storeClockInEndDate, storeClockInSwitch, storeClockInLoading };
};

const mapDispatchToProps = (dispatch) => ({
  getWebClockIn: (storeUserId) => dispatch(getWebClockIn(storeUserId)),
  postWebClockIn: (isSwitch, storeUserId, type, callBack) => dispatch(postWebClockIn(isSwitch, storeUserId, type, callBack)),
  setClockInStartDate: (res) => dispatch(setClockInStartDate(res)),
  setClockInEndDate: (res) => dispatch(setClockInEndDate(res)),
  setClockInSwitch: (res) => dispatch(setClockInSwitch(res))
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingModal);